import CryptoIcon from "../CryptoIcon";
import DropdownIcon from "assets/icons/dropdown.svg";
import {ReactComponent as SearchIcon} from "assets/icons/search.svg";
import {ReactComponent as NotFoundIcon} from "assets/icons/notFound.svg";
import toast from 'react-hot-toast';
import "./style.scss";
import useWindowDimensions from "helpers/screen";
import { useEffect, useState } from "react";
import { formatNumber } from "helpers/helpers";
import ChangeIndicator from "../ChangeIndicator";
import { findCoinFrom } from "ts/accountInfo/tokens";
import { Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import state from "redux/state";

const MarketSelector = ({marketData, updateMarket}) => {

  const {width} = useWindowDimensions();
  const [marketsDropdown, setMarketsDropdown] = useState(false);
  const state = useSelector((state) => state.storage);
  const [selectedMarket, setSelectedMarket] = useState();
  const [fromCoin, setFromCoin] = useState("SOL");
  const [toCoin, setToCoin] = useState("USDC");

  const [searchInput, setSearchInput] = useState("");
  const [searchedMarkets, setSearchedMarkets] = useState([]);

  useEffect(() => { // Detect / shortcut press
    window.addEventListener("keyup", listenKeyPress);
    return () => window.removeEventListener("keyup", listenKeyPress);
  }, []);

  function listenKeyPress(event) {
    if (event.keyCode === 191) {
      setMarketsDropdown(!marketsDropdown);
    }
  }

  useEffect(() => { // Filter markets by search
    if(searchInput.length > 2) {
      let filteredArray = [];
      let first = searchInput.split("-")[0];
      let second = searchInput.split("-")[1] || "";
      // console.log("markets0", searchInput.split("-")[0] || "", searchInput.split("-")[1] || "");
      for(let i = 0; i < state.markets.length; i++) {
        let mkt = state.markets[i];
        // if(second){
        //   console.log("market quote token", mkt.quoteToken?.symbol);
        // }
        if(second) {
          if(mkt.baseToken && mkt.baseToken.address.toLowerCase().indexOf(first.toLowerCase()) !== -1 &&
          (mkt.quoteToken?.address.toLowerCase().indexOf(second.toLowerCase()) !== -1))
            filteredArray.push(mkt);
          else if(mkt.baseToken && mkt.baseToken.symbol.toLowerCase().indexOf(first.toLowerCase()) !== -1 &&
          (mkt.quoteToken?.symbol.toLowerCase().indexOf(second.toLowerCase()) !== -1))
            filteredArray.push(mkt);
          else if(mkt.baseToken && mkt.baseToken.name.toLowerCase().indexOf(first.toLowerCase()) !== -1 &&
          (mkt.quoteToken?.name.toLowerCase().indexOf(second.toLowerCase()) !== -1))
            filteredArray.push(mkt);
          else if(mkt.market.toLowerCase().indexOf(searchInput.toLowerCase()) !== -1)
            filteredArray.push(mkt);
        }
        else {
          if(mkt.baseToken && mkt.baseToken.address.toLowerCase().indexOf(first.toLowerCase()) !== -1)
            filteredArray.push(mkt);
          else if(mkt.baseToken && mkt.baseToken.symbol.toLowerCase().indexOf(first.toLowerCase()) !== -1)
            filteredArray.push(mkt);
          else if(mkt.baseToken && mkt.baseToken.name.toLowerCase().indexOf(first.toLowerCase()) !== -1)
            filteredArray.push(mkt);
          else if(mkt.market.toLowerCase().indexOf(searchInput.toLowerCase()) !== -1)
            filteredArray.push(mkt); 
        }
      }
      setSearchedMarkets(filteredArray);
    }
  },[searchInput])

  useEffect(() => {
    if(marketData.market) {
      setFromCoin(marketData.pairs.base.symbol);
      setToCoin(marketData.pairs.quote.symbol);
      // setFromCoin(findCoinFrom(state.tokenList.tokens, undefined, marketData.market.baseMint.toBase58()).symbol );
      // setToCoin(findCoinFrom(state.tokenList.tokens, undefined, marketData.market.quoteMint.toBase58()).symbol );
      setSelectedMarket(marketData.market.ownAddress.toBase58())
    }
  }, [marketData]);

  
  return <>
    <div className="marketSelector disable-select">
      <div className="marketSelectorButton" onClick={() => setMarketsDropdown(() => !marketsDropdown)}>
        <div className="tickerInfo">
          <CryptoIcon symbol={fromCoin}/>
          <p className="ticker">{fromCoin}-{toCoin}</p>
        </div>
        <div className="marketsDropdown">
          { width > 375 &&
            (marketsDropdown ?
            <p className="allMarkets">Click to Close</p>
            :
            <p className="allMarkets">All Markets</p>)
          }
          { marketsDropdown ?
            <img className="dropdownIcon" style={{transform:"rotate(180deg)"}} src={DropdownIcon}/>
            :
            <img className="dropdownIcon" src={DropdownIcon}/>
          }
          <Tooltip title={"Shortcut: Press / on your keyboard to open dropdown"}>
            <p className="shortcutIcon" style={{marginLeft:"0.5rem"}}>
              /
            </p>
          </Tooltip>
        </div>
      </div>
      
      {
      marketsDropdown &&
      <div className="marketsDropdownOpened">
        <div className="coinTickerList">
          <div className="searchBar">
            <SearchIcon stroke="var(--gray500)"/>
            <input value={searchInput} onChange={(e) => setSearchInput(e.target.value)} className="search" autoFocus placeholder="Search by name, symbol or market address"/>
          </div>
          { searchInput.length < 3 ? // Only search markets if input length > 2 characters
            state.markets &&
              state.markets.map((item, i) => {
                if(item.baseToken && item.quoteToken)
                return <div className={item.market === selectedMarket ? "coinTicker _selected" : "coinTicker"} key={i} onClick={() => {
                    window.history.replaceState(null, item.baseToken.symbol + "-" + item.quoteToken.symbol + " | Prism Pro", "/?trade="+item.baseToken.symbol + "-" + item.quoteToken.symbol)

                    updateMarket({base: item.baseToken.address, quote: item.quoteToken.address});
                    setMarketsDropdown(() => !marketsDropdown)
                  }
                }>
                  <div className="coinTickerInfo">
                    <img className="imageCircle" src={item.baseToken.logoURI} width={25} height={25}/>
                    <p className="tickerName">{item.baseToken.symbol + "-" + item.quoteToken.symbol}</p>
                    <p className="tickerWrapper">{item.baseToken.symbol}</p>
                    <p className="tickerWrapper">{item.quoteToken.symbol}</p>
                  </div>
                  {/* <div className="coinTickerPrice">
                    <p className="price">${formatNumber(item.priceUSD)}</p>
                    <ChangeIndicator change={item.change} showFull={false}/>
                  </div> */}
                </div>
              })
              :
              // show filtered items 
              (
                searchedMarkets.length > 0 ?
                searchedMarkets.map((item, i) => {
                  if(item.baseToken && item.quoteToken)
                  return <div className={item.market === selectedMarket ? "coinTicker _selected" : "coinTicker"} key={i} onClick={() => {
                    window.history.replaceState(null, item.baseToken.symbol + "-" + item.quoteToken.symbol + " | Prism Pro", "/?trade="+item.baseToken.symbol + "-" + item.quoteToken.symbol)
                    updateMarket({base: item.baseToken.address, quote: item.quoteToken.address});
                      setMarketsDropdown(() => !marketsDropdown)
                    }
                  }>
                    <div className="coinTickerInfo">
                      <img className="imageCircle" src={item.baseToken.logoURI} width={25} height={25}/>
                      <p className="tickerName">{item.baseToken.symbol + "-" + item.quoteToken.symbol}</p>
                      <p className="tickerWrapper">{item.baseToken.symbol}</p>
                      <p className="tickerWrapper">{item.quoteToken.symbol}</p>
                    </div>
                  </div>
                })
                :
                <div className="marketNotFound">
                  <div className="icon">
                    <NotFoundIcon fill={"var(--gray200)"}/>
                  </div>
                  <p className="label">
                    Market not found, but you can create one!
                  </p>
                </div>
              )
          }
        </div>
        
      </div>
    }
    </div>
    
  </>
}

export default MarketSelector;


const mock = [
  {
    name: "Bitcoin",
    symbol: "BTC",
    priceUSD: 40842.57,
    change: {
      percentage: 4.23,
      amount: 1304.21
    },
    pair: {
      base: "BTC",
      quote: "USDC"
    },
    market: "A8YFbxQYFVqKZaoYJLLUVcQiWP7G2MeEgW5wsAQgMvFw"
  },
  {
    name: "Ethereum",
    symbol: "ETH",
    priceUSD: 3021.31,
    change: {
      percentage: 1.30,
      amount: 104.40
    },
    pair: {
      base: "ETH",
      quote: "USDC"
    },
    market: "8Gmi2HhZmwQPVdCwzS7CM66MGstMXPcTVHA7jF19cLZz"
  },
  {
    name: "Solana",
    symbol: "SOL",
    priceUSD: 102.25,
    change: {
      percentage: 4.27,
      amount: 2.31
    },
    pair: {
      base: "SOL",
      quote: "USDC"
    },
    market: "9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT"
  },
  {
    name: "Prism",
    symbol: "PRISM",
    priceUSD: 0.01324,
    change: {
      percentage: 6.40,
      amount: 0.006
    },
    pair: {
      base: "PRISM",
      quote: "USDC"
    },
    market: "2MvXnxngd1gKp6gE8Q63wiPHSpveWcx8x4wf43VpyiA6"
  }
]
